import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@circle-react/helpers/communityMemberHelpers";

export const useCanRecordVoiceInPosts = () => {
  const { currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  const isAdminFlagEnabled = Boolean(
    currentCommunitySettings?.voice_messages_in_posts_enabled,
  );
  const isAdminOrModerator =
    isCommunityAdmin(currentCommunityMember) ||
    isCommunityModerator(currentCommunityMember);

  return isAdminOrModerator || isAdminFlagEnabled;
};
